import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { routeTree } from "./routeTree.gen";
import { startAutoSync } from "./lib/offline/sync";
import "./styles.css";

// TanStack Query con persistencia (las lecturas sobreviven a recargas/offline).
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, gcTime: 24 * 60 * 60 * 1000, retry: 2 } },
});
const persister = createSyncStoragePersister({ storage: window.localStorage, key: "ferresaas.query" });

// Router type-safe (el árbol lo genera el plugin de TanStack en build/dev).
const router = createRouter({ routeTree });
declare module "@tanstack/react-router" {
  interface Register { router: typeof router }
}

// Arranca el sincronizador de la cola de ventas offline.
startAutoSync();

// Refleja el estado de red en el shell (tiñe el tope de púrpura offline).
const setOffline = () => document.body.setAttribute("data-offline", String(!navigator.onLine));
setOffline();
window.addEventListener("online", setOffline);
window.addEventListener("offline", setOffline);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
      <RouterProvider router={router} />
    </PersistQueryClientProvider>
  </React.StrictMode>,
);
